import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { SharedModule } from "src/app/shared/shared.module";
import { ReducedEmissionComponent } from "./reducedgas/reducedgas";

@NgModule({
  imports: [
    BrowserModule,
    SharedModule,
  ],
  declarations: [
    ReducedEmissionComponent,
  ],
  exports: [
    ReducedEmissionComponent,
  ],
})
export class ReducedEmissionComponents { }
